import React, { Component } from "react";
import '../css/documentation.scss';

export class ViewLocationScheduledHelp extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="section__content section__content--p30 createContent">
                    <div className="container-fluid">
                        <h1 style={{ fontSize: '36px', marginTop: '30px' }}>How To View Locations Scheduled Publishing</h1>
                        <p className="dateFormat" style={{ fontSize: '14px', color: 'grey' }}>18/11/2021 ▪ 6 minutes to read</p>
                        <br /><br />
                        <div class="webMgmt container-fluid">
                            <ol>
                                <li class="createList">
                                    Using the menu on the left, click on "Website Management", then click on the "Locations" link. This will take you to the Locations Listing Page.  <br />
                                    <img src="/img/documentation-img/location/location_navbar.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    To view Locations Scheduled Publishing, click on "Scheduled Publishing".<br />
                                    <img src="/img/documentation-img/location/scheduled_publishing.png" class="userImage" />
                                </li>

                                <li class="createList">
                                    To view Locations Scheduled Publishing Details, click on any scheduled publishing listing.<br />
                                    <img src="/img/documentation-img/location/select_scheduled_locations_details.png" class="userImage" />

                                </li>

                                <li class="createList">
                                    To view the preview image of the locations, click on the “Preview” button, under the “Photos” section.<br />
                                    <img src="/img/documentation-img/location/view_preview_button.png" class="userImage" />
                                </li>

                                <li class="createList">
                                    The photo will then be shown. Click on the X on the top right corner to cancel Preview.<br />
                                    <img src="/img/documentation-img/location/preview_image.png" class="userImage" />
                                </li>

                            </ol>
                            <div className="text-right">
                                <a href="/documentation/locations/editLocationHelp" className="btn btn-primary">&laquo; Edit Location</a>&nbsp;
                                <a href="/documentation/locations/editLocationScheduledHelp" className="btn btn-primary">Edit Scheduled Location &raquo;</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}